import { SVGProps } from 'react';

export const LogoZh = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="784" height="250" viewBox="0 0 784 250" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M657.083 74.003 611.512 58.68V35.795l45.571 15.323zm80.595 45.372V213.9H713.4v-94.525h-47.561l-1.791-21.094H713.4V34.8h24.278v63.48h45.571v21.095zm-91.739 55.919 32.835-14.328v25.671l-57.113 25.074-4.179-24.079 4.577-1.99c1.99-10.348 2.587-19.701 2.587-31.243v-46.168c0-1.791-1.194-2.985-2.985-2.985h-16.119l-1.99-20.696h30.646c8.955 0 13.93 4.975 13.93 13.93v53.133c0 9.552-.597 16.915-2.189 23.681"
        fill="#FA9D39"
      />
      <path
        d="M443.158 185.841c0 1.791.995 3.184 2.786 3.184h24.477c1.99 0 2.786-1.194 2.786-3.184v-23.084c0-1.99-.796-2.985-2.786-2.985h-24.477c-1.99 0-2.786.995-2.786 2.985zm127.161-123.38h13.731v20.696h-30.248v23.283h27.064v20.696h-27.064v22.089h31.442v20.696h-31.442v45.969H530.32v-45.969h-30.049l-2.189-20.696h32.238v-22.089h-24.875l-1.99-20.696h26.865V83.157h-28.258l-1.99-20.696h15.323l-5.97-27.661h21.492l5.97 27.66h10.945l8.159-27.66h22.487zm-79.202 31.442v18.308c0 12.338-4.577 16.716-16.716 16.716h-27.263c-1.194 3.98-2.587 7.96-4.179 11.741h37.014c8.955 0 14.726 6.169 14.726 15.522v36.417c0 9.353-5.771 15.522-14.726 15.522h-43.581c-8.955 0-14.726-6.169-14.726-15.522v-15.522c-3.98 5.174-8.557 10.149-13.333 15.124l-6.368-25.87c10.149-11.144 17.711-23.283 22.686-37.412h-12.537l-1.99-19.104h19.502c.796-4.975 1.393-10.348 1.791-15.92h-25.074L404.552 74.4h27.064V58.68h-19.502l-1.99-19.104h64.277c11.542 0 16.716 4.776 16.716 16.716V74.4h7.761v19.502zm-22.288 0h-15.323a105.4 105.4 0 0 1-1.791 15.92h14.328c1.99 0 2.786-.597 2.786-2.786zm0-19.502V61.466c0-1.99-.796-2.786-2.786-2.786h-12.139V74.4z"
        fill="#734BF7"
      />
      <path
        d="M250.022 0c-22.757 0-44.103 6.09-62.488 16.72 37.355 21.604 62.488 61.957 62.488 108.194H125.011c0 46.236 25.133 86.59 62.488 108.16 18.385 10.63 39.731 16.719 62.489 16.719 69.065 0 125.012-55.938 125.012-124.914S319.053 0 250.022 0"
        fill="url(#a)"
      />
      <path
        d="M187.499 16.72c-37.355 21.604-62.488 61.957-62.488 108.194h125.011c0-46.237-25.133-86.59-62.488-108.195z"
        fill="url(#b)"
      />
      <path
        d="M187.5 16.72c37.356 21.604 62.489 61.957 62.489 108.194H124.977c0 46.236 25.133 86.59 62.489 108.16-18.385 10.63-39.731 16.719-62.489 16.719C55.982 249.828 0 193.89 0 124.914S55.982 0 125.012 0c22.757 0 44.103 6.09 62.488 16.72"
        fill="url(#c)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity=".3"
        d="M125.011 124.914h125.011l-62.419 108.229s-.069 0-.069-.035c-37.356-21.604-62.489-61.958-62.489-108.16z"
        fill="url(#d)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity=".3"
        d="M125.012 125.121c0 46.236 25.133 86.589 62.488 108.16C169.115 243.911 147.769 250 125.012 250c-22.758 0-44.035-6.089-62.42-16.685l62.385-108.194z"
        fill="url(#e)"
      />
      <defs>
        <linearGradient id="a" x1="348.125" y1="44.687" x2="134.375" y2="250" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FBB03B" />
          <stop offset="1" stopColor="#F24D2C" />
        </linearGradient>
        <linearGradient id="b" x1="61.696" y1="218.762" x2="259.617" y2="28.949" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFCF8E" />
          <stop offset="1" stopColor="#FF8B79" />
        </linearGradient>
        <linearGradient id="c" x1="75.625" y1="7.812" x2="140.937" y2="194.375" gradientUnits="userSpaceOnUse">
          <stop stopColor="#9669FF" />
          <stop offset="1" stopColor="#4726EC" />
        </linearGradient>
        <linearGradient id="d" x1="187.534" y1="333.184" x2="187.534" y2="128.285" gradientUnits="userSpaceOnUse">
          <stop offset=".49" stopColor="#fff" />
          <stop offset=".54" stopColor="#F2F2F2" />
          <stop offset=".62" stopColor="#D1D1D1" />
          <stop offset=".73" stopColor="#9B9B9B" />
          <stop offset=".87" stopColor="#515151" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient id="e" x1="86.83" y1="292.246" x2="160.734" y2="171.752" gradientUnits="userSpaceOnUse">
          <stop offset=".49" stopColor="#fff" />
          <stop offset=".54" stopColor="#F2F2F2" />
          <stop offset=".62" stopColor="#D1D1D1" />
          <stop offset=".73" stopColor="#9B9B9B" />
          <stop offset=".87" stopColor="#515151" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};
